import {baseApi} from "./apiService";
import {PaginationCamel} from "../types";

export interface PublicBarberShopAddress {
    city: string;
    latitude: number | null;
    longitude: number | null;
}

export interface PublicBarberShopService {
    name: string;
    price: number;
}

export interface PublicBarberShop {
    id: string;
    name: string;
    slug: string;
    logo: string | null;
    primary_color: string | null;
    opening_hours: Record<string, string[][]>;
    time_zone: string;
    currency: string;
    average_rating: number | null;
    review_count: number;
    address: PublicBarberShopAddress | null;
    services: PublicBarberShopService[];
}

export interface SearchBarberShopsParams {
    search?: string;
    page?: number;
    limit?: number;
}

export const publicApi = baseApi.injectEndpoints({
    overrideExisting: false,
    endpoints: (builder) => ({
        // Envelope switched to the camelCase Pagination DTO (2026-07 contract);
        // rows unchanged (still carry average_rating / review_count inline).
        searchBarberShops: builder.query<PaginationCamel<PublicBarberShop>, SearchBarberShopsParams>({
            query: ({search = '', page = 1, limit = 20}) => ({
                url: `public/barbershops?search=${encodeURIComponent(search)}&page=${page}&limit=${limit}`,
                method: 'GET',
            }),
            providesTags: ['PublicBarberShops'],
        }),
    }),
})

export const {
    useSearchBarberShopsQuery,
    useLazySearchBarberShopsQuery,
} = publicApi
